import s from './IotGatewayGraphic.module.scss';

// [2026-09-09 사용자] 회사소개 인사말 그래픽 = 'EVS IoT Gateway 키비주얼'.
//   ★그라디언트 금지(사용자 "그라디언트 싫어") → 전부 플랫/솔리드. 다크 필드 + 동심 궤도(플랫) + 4노드 + 중앙 텍스트.
//   ★[2026-09-10 사용자 교정] 본문 '소규모→산업 현장', '대기오염→안전과 대기환경'.
//     ★노드 4개 = 산업안전보건 제품·철학 + 클라우드(사용자): 클라우드(SaaS)·체감온도계(온열질환)·경보 벨·안전모.
//     (이전엔 환경/게이트웨이/계측기 혼합 → 안전보건+클라우드 테마로 교체.)
//   텍스트=EVS 브랜드 토큰(그린 #35c17e / 청량 시안 #1FB2EE), 새 색 발명 금지.
const CX = 490, CY = 330, R = 288;
const GREEN = '#35c17e', CYAN = '#1FB2EE'; // 시안=청량한 파랑(사용자 2026-09-09)

// [2026-09-10 사용자] 4노드 = 산업안전보건 제품·철학 + 클라우드로 교체.
//   클라우드(SaaS 통합관제)·체감온도계(온열질환/폭염 = EVS 안전 대표제품)·다채널 경보·안전모(근로자 안전보건).
const ICONS: Record<string, JSX.Element> = {
  cloud: <><path d="M6.6 18a4 4 0 0 1 .4-7.98 5.2 5.2 0 0 1 10-1 3.7 3.7 0 0 1-.4 8.98z" /><path d="M12 16.4v-5M9.9 13.3 12 11.2l2.1 2.1" /></>, // 클라우드 — SaaS 통합관제/데이터
  thermo: <><path d="M12 3a2.3 2.3 0 0 1 2.3 2.3v8.4a4 4 0 1 1-4.6 0V5.3A2.3 2.3 0 0 1 12 3z" /><circle cx="12" cy="16.2" r="1.6" fill="currentColor" stroke="none" /></>, // 체감온도계 — 온열질환/폭염
  bell: <><path d="M12 4a5 5 0 0 0-5 5c0 5.5-2 7-2 7h14s-2-1.5-2-7a5 5 0 0 0-5-5z" /><path d="M10.3 20a1.9 1.9 0 0 0 3.4 0" /></>, // 다채널 경보/알림
  // [2026-09-10 사용자] 안전모(hard hat)가 작게 그리면 '머리+돔'으로 오독됨 → 명확한 방패(안전 보호)로 교체.
  shield: <><path d="M12 3l7 2.6v5.3c0 4.5-3 7.9-7 9.1-4-1.2-7-4.6-7-9.1V5.6z" /><path d="M9 11.8l2.1 2.1 4-4.2" /></>, // 안전 보호 — 근로자 산업안전보건(방패+체크)
};
const NODES = [
  // glow = 코멧(.arc, 22s 시계방향, 머리 시작 ~25°/3시부근)이 그 아이콘 각도에 닿는 시각(초) → 통과 시 발광 동기화.
  { a: -90, icon: 'cloud', color: GREEN, glow: 15 },     // 12시 — SaaS 통합관제(클라우드)
  { a: 0, icon: 'thermo', color: CYAN, glow: 20.5 },     // 3시 — 체감온도계(온열질환)
  { a: 90, icon: 'bell', color: CYAN, glow: 4 },         // 6시 — 다채널 경보
  { a: 180, icon: 'shield', color: GREEN, glow: 9.5 },   // 9시 — 근로자 안전보건(방패)
];

export default function IotGatewayGraphic() {
  return (
    <div className={s.card} role="img" aria-label="EVS IoT Gateway 키비주얼 — 사물에 인터넷을 결합해 산업 현장의 안전과 대기환경을 실시간 모니터링">
      <svg className={s.bg} viewBox="0 -34 980 728" preserveAspectRatio="xMidYMid meet">
        <defs>
          {/* 코멧 꼬리: 투명 → 시안(머리) 페이드 */}
          <linearGradient id="kvComet" gradientUnits="userSpaceOnUse" x1="368" y1="69" x2="751" y2="452">
            <stop offset="0" stopColor={CYAN} stopOpacity="0" /><stop offset="1" stopColor={CYAN} stopOpacity="1" />
          </linearGradient>
          {/* 머리 글로우 */}
          <filter id="kvGlow" x="-70%" y="-70%" width="240%" height="240%"><feGaussianBlur stdDeviation="6" /></filter>
        </defs>
        <circle cx={CX} cy={CY} r={R} fill="none" stroke="#222B39" strokeWidth="1.2" />
        <circle className={s.flow} cx={CX} cy={CY} r={R} fill="none" stroke="#3a4a63" strokeWidth="1.6" strokeDasharray="2 14" strokeLinecap="round" />
        {/* 회전 코멧 아크(글로우 머리 + 페이드 꼬리) — 사용자 지정 방식 */}
        <g className={s.arc}>
          <path d="M368 69 A288 288 0 0 1 751 452" fill="none" stroke="url(#kvComet)" strokeWidth="3" strokeLinecap="round" />
          <circle className={s.glowHead} cx="751" cy="452" r="8" fill={CYAN} filter="url(#kvGlow)" />
          <circle cx="751" cy="452" r="3.4" fill="#e2fbff" />
        </g>
        <circle cx={CX} cy={CY} r={242} fill="none" stroke="#1C2431" strokeWidth="1.2" />
        <circle className={s.breathe} cx={CX} cy={CY} r={242} fill="none" stroke={GREEN} strokeWidth="1.4" />

        {NODES.map((n) => {
          const rad = (n.a * Math.PI) / 180;
          const x = CX + R * Math.cos(rad), y = CY + R * Math.sin(rad);
          return (
            <g key={n.icon} className={s.node} style={{ animationDelay: `${n.glow}s`, ['--nodeGlow' as string]: n.color }} transform={`translate(${x - 34}, ${y - 34})`}>
              <rect width="68" height="68" rx="19" fill="#131720" stroke={n.color} strokeOpacity=".46" strokeWidth="1" />
              <g transform="translate(14, 14) scale(1.67)" fill="none" stroke={n.color} strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round">
                {ICONS[n.icon]}
              </g>
            </g>
          );
        })}
      </svg>

      <div className={s.center}>
        <span className={s.badge}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 18.6 6.1 20.8l1.2-6.6L2.5 9l6.6-.9z" /></svg>
          24년도 IoT통신 전송률 우수제조업체 선정(한국환경공단)
        </span>
        <p className={s.sub}>(IoT 실시간 모니터링 시스템)</p>
        <h3 className={s.title}>IoT Gateway</h3>
        <span className={s.rule} aria-hidden="true" />
        <p className={s.body}>산업 현장의 안전과 대기환경을 위한<br />실시간 IoT 모니터링</p>
        <p className={s.quote}>“사물에 인터넷을 결합시키다”</p>
      </div>
    </div>
  );
}
